// extracted by css-extract-rspack-plugin
export default {"dropdownNavbarItemMobile":"dropdownNavbarItemMobile_NTht"};